import { ThemeProvider } from '@brand/theme';
import { PrismicProvider } from '@prismicio/react';
import 'locales/i18n';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import React from 'react';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import Redirect from 'services/httpClient/Redirect';
import { client } from 'services/prismic';
import { store } from 'store';

const App = ({ Component, pageProps }: AppProps) => {
  const persistor = persistStore(store);
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <PrismicProvider client={client}>
          <ThemeProvider>
            <Head>
              <title>RIK | Jaimy by Belfius</title>
              <meta content="Jaimy by Belfius" property="og:title" />
              <meta content="website" property="og:type" />
            </Head>
            <Component {...pageProps} />
            <Redirect />
          </ThemeProvider>
        </PrismicProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
